import { acaNamesSUSTAINABLE } from '../src/aca-names-SUSTAINABLE';
export const acaNames = acaNamesSUSTAINABLE;
